import { createSelector } from '@reduxjs/toolkit';
import { selectFurniture } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'С мебелью', value: true },
  { label: 'Без мебели', value: false },
];

export const selectFurnitureFilter = createSelector(selectFurniture, value => ({
  label: 'Мебель',
  options: OPTIONS,
  value: [value ?? null],
}));
